import './front.scss';
import { CalloutTextFront } from './CalloutTextFront.js';

new CalloutTextFront( document ).init();
